<div class="bookmarks-container">
 <app-sidenav-header title="{{'BOOKMARKS.BOOKMARKS' | transloco }}"></app-sidenav-header>
    <div *ngIf="!isLoading && !bookmarkList?.length && !searchText" class="empty-state">
        <img class="bookmark-img" src="/assets/images/bookmark_image.png">
        <div class="fs-20 fw-600 mt-8 no-bookmark">{{'BOOKMARKS.NO_BOOKMARK' | transloco }}</div>
        <div class="fs-16 fw-500 mt-8 save-bookmark">{{'BOOKMARKS.SAVE_BOOKMARK' | transloco }}</div>
        <button class="white mt-32" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CLOSE' | transloco}}</button>
    </div>
    <div *ngIf="!isLoading && bookmarkList?.length" class="search-box">
        <input class="fs-14 fw-500 search" type="text" placeholder="Search" [(ngModel)]="searchText" (ngModelChange)="onSearch()">
        <mat-icon class="icon-search icon-md" svgIcon="search"></mat-icon>
    </div>
    <div *ngIf="searchText && groupedBookmarks.length === 0 && searchText" class="empty-state">
        <img src="/assets/images/no-data.png" alt="No data found" />
        <div class="fs-16 fw-500 mt-8 no-bookmark">{{'COMMON_MESSAGE.NO_RESULTS_FOUND' | transloco | titlecase }}</div>
    </div>
    <div *ngIf="!isLoading" class="accordion">
        <div *ngFor="let group of groupedBookmarks" class="accordion-item">
            <div class="accordion-header" (click)="toggleGroup(group)">
                <div class="left">
                    {{ group.tenantName || transloco | titlecase }}
                </div>
                <div class="center">
                    <span>{{'TENANT_DASHBOARD.INSTANCES' | transloco }}</span>
                    <span class="fs-12 fw-500 badge">{{ group.environments.length | number:'2.0' }}</span>
                </div>
                <div class="right">
                    <mat-icon svgIcon="keyboard_arrow_up" *ngIf="group.expanded"></mat-icon>
                    <mat-icon svgIcon="keyboard_arrow_down" *ngIf="!group.expanded"></mat-icon>
                </div>
            </div>

            <div class="accordion-body" *ngIf="group.expanded">
                <div class="fs-10 fw-700 env-header">{{'TENANT_DASHBOARD.INSTANCES' | transloco | uppercase}}</div>
                <div class="item-enclosure">
                    <ng-container *ngIf="deletingGroupId === group.tenantName; else normalBody">
                            <div class="skeleton-card">
                                <div class="skeleton-row" *ngFor="let row of group.environments">
                                <div class="skeleton-line"></div>
                                <div class="skeleton-icon"></div>
                            </div>
                        </div>
                    </ng-container>
                <ng-template #normalBody>
                <div class="env-item" *ngFor="let env of group.environments; let last = last" [class.no-border]="last">
                    <div class="env-inner" [class.no-border]="last" (click)="!deletingGroupId && rowClick(env)">
                        <span class="fs-14 fw-500 env-link">{{ env.name }}</span>
                        <button class="delete-btn" (click)="deleteBookmark(env.bookmarkId, group.tenantName); $event.stopPropagation()" [disabled]="deletingGroupId !== null">
                            <mat-icon svgIcon="delete" class="icon-md mr-4 delete"></mat-icon>
                        </button>
                    </div>
                </div>
                </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>